import React, { useImperativeHandle } from "react";
import {
  FDocligneInvoiceInterface,
  InvoiceInterface,
  InvoiceTaskInterface,
} from "../../../interfaces/EdiInterface";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Typography from "@mui/material/Typography";
import {
  doTypeDtos,
  SAGE_DO_TYPE_ACHAT_CC,
  SAGE_DO_TYPE_ACHAT_DA,
  SAGE_DO_TYPE_ACHAT_FA,
  SAGE_DO_TYPE_ACHAT_LI,
  SAGE_DO_TYPE_ACHAT_PC,
} from "../../../utils/DoceneteteUtils";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import {
  addDisplayInvoiceFDocligne,
  getGlobalNewDoc,
  getNewDoc,
} from "../../../helpers/FDocenteteHelper";
import { priceFormat } from "../../../utils/FormatUtils";
import { getUrlFArticleImage } from "../../../helpers/FileHelper";
import { IMAGE_SIZE_LOGO } from "../../../utils/FileUtils";
import Box from "@mui/material/Box";
import { PRODUCT_PAGE } from "../../../utils/RouteUtils";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import HideImageIcon from "@mui/icons-material/HideImage";
import {
  Alert,
  Container,
  Select,
  TextareaAutosize,
  Theme,
  Tooltip,
} from "@mui/material";
import SearchComponent from "../SearchComponent";
import CopyClipboardComponent from "../CopyClipboardComponent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import { SxProps } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import { requestApi } from "../../../helpers/RequestApi";
import { PATCH } from "../../../utils/MethodUtils";
import getErrorApi from "../../../helpers/GetErrorApi";
import { toastr } from "react-redux-toastr";
import { INVOICE_URL } from "../../../utils/UrlsUtils";
import { set } from "../../../app/globalSlice";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";

const clone = require("clone");

interface State {
  initInvoice: InvoiceInterface | undefined;
}

interface State2 {
  fDocligne: FDocligneInvoiceInterface;
  doTypeDtos: DoTypeInvoiceInterface[];
  index: number;
  tasks: InvoiceTaskInterface[];
  doPieceDestination: string | null;
}

interface State3 {
  doTypeDtos: DoTypeInvoiceInterface[];
  task: InvoiceTaskInterface;
  doPieceDestination: string | null;
  index: number;
}

interface State4 {
  invoice: InvoiceInterface | undefined;
  doTypeDtos: DoTypeInvoiceInterface[];
  index: number;
}

interface State5 {
  fDocligne: FDocligneInvoiceInterface;
}

interface State6 {
  initInvoice: InvoiceInterface | undefined;
  setInvoice: Function;
}

export interface DoTypeInvoiceInterface {
  doType: number;
  suffix: string | null;
  color: string;
}

export interface CheckedInterface {
  dlNo: number;
  doPiece: string;
  doType: number;
}

const colSpanFDocligne = 5;
const colSpanTask = 4;

const FDocenteteHeader = React.memo(
  React.forwardRef(({ fDocligne }: State5, _) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const fournisseurs = useAppSelector(
      (state: RootState) => state.globalState.fournisseurs
    );
    const thisFournisseur = fournisseurs?.find(
      (f) => f.userIdentifier === fDocligne.ctNum
    );

    return (
      <>
        <Typography
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              color: theme.palette.primary.main,
              fontWeight: "bold",
            }}
          >
            {thisFournisseur?.ctIntitule}{" "}
            <CopyClipboardComponent
              className="RobotoMono"
              component="span"
              text={fDocligne.ctNum}
              sx={{ wordBreak: "keep-all" }}
            />
          </span>
          <CopyClipboardComponent
            className="RobotoMono"
            component="span"
            text={fDocligne.fDocentete.doPiece}
            sx={{ wordBreak: "keep-all" }}
          />
          <span>
            {t("word.doStatut.label") + ": "}
            <span
              style={{
                fontWeight: "bold",
                color: theme.palette.primary.main,
              }}
            >
              {fDocligne.fDocentete.doStatutString}
            </span>
          </span>
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingY: 0 }}>
                {t("word.commentaires")}
              </TableCell>
              <TableCell sx={{ paddingY: 0 }}>{t("word.doDatelivr")}</TableCell>
              <TableCell sx={{ paddingY: 0 }}>{t("word.doRef")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ paddingY: 0 }}>
                {fDocligne.fDocentete.commentaires}
              </TableCell>
              <TableCell sx={{ paddingY: 0 }}>
                {new Date(fDocligne.fDocentete.doDatelivr).toLocaleString(
                  i18n.language,
                  {
                    dateStyle: "long",
                    timeZone: "America/Cuiaba",
                  }
                )}
              </TableCell>
              <TableCell sx={{ paddingY: 0 }}>
                {fDocligne.fDocentete.doRef}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  })
);

const transformDoTypes = [SAGE_DO_TYPE_ACHAT_PC, SAGE_DO_TYPE_ACHAT_LI];

const InvoiceTaskComponent = React.memo(
  React.forwardRef(
    ({ task, doTypeDtos, doPieceDestination, index }: State3, ref) => {
      const { t, i18n } = useTranslation();
      const theme = useTheme();
      const getChecked = React.useCallback(() => {
        if (task.possibleFDoclignes && task.possibleFDoclignes.length > 0) {
          return undefined;
        }
        return null;
      }, [task.possibleFDoclignes]);
      const [checked, setChecked] = React.useState<
        undefined | null | CheckedInterface
      >(getChecked());
      const [error, setError] = React.useState<string | undefined>(undefined);

      const getValue = React.useCallback(() => {
        if (checked === undefined) {
          setError(t("sentence.selectValueOption"));
          return undefined;
        }
        const r: any = {
          ...task,
          ...(checked?.dlNo && {
            dlNo: checked.dlNo,
            arRef: null,
            doPiece: checked.doPiece,
            doType: checked.doType,
          }),
          todo: true,
          doPieceDestination: doPieceDestination,
          doTypeDestination: SAGE_DO_TYPE_ACHAT_CC,
        };
        r.oldId = r.id;
        delete r.id;
        delete r.done;
        return r;
      }, [checked, doPieceDestination, t, task]);

      useImperativeHandle(ref, () => ({
        getValue() {
          return getValue();
        },
      }));

      React.useEffect(() => {
        setChecked(getChecked());
      }, [task.arRef, task.done]); // eslint-disable-line react-hooks/exhaustive-deps

      let lastDoPiece = "";
      return (
        <>
          <TableRow
            sx={{
              ...(index % 2 === 0 && {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
              }),
            }}
          >
            {doTypeDtos.map((doTypeDto) => (
              <React.Fragment key={doTypeDto.doType}>
                {transformDoTypes.includes(doTypeDto.doType) &&
                task.fArticle?.arRef ? (
                  <>
                    <TableCell sx={{ border: "none" }}>
                      <Link
                        to={PRODUCT_PAGE + "/" + task.fArticle.arRef}
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                        }}
                      >
                        {task.fArticle.fArticleProp.images ? (
                          <img
                            src={
                              (process.env.REACT_APP_API_URL ?? "") +
                              getUrlFArticleImage(
                                task.fArticle.arRef,
                                task.fArticle.fArticleProp.images[0],
                                IMAGE_SIZE_LOGO
                              )
                            }
                            className={"objectFitCover"}
                            alt={
                              "[" +
                              task.fArticle.arRef +
                              "] " +
                              task.fArticle.arDesign
                            }
                            loading="lazy"
                            referrerPolicy="no-referrer"
                          />
                        ) : (
                          <HideImageIcon
                            sx={{
                              width: IMAGE_SIZE_LOGO,
                              height: IMAGE_SIZE_LOGO,
                            }}
                          />
                        )}
                      </Link>
                    </TableCell>
                    <TableCell sx={{ border: "none" }}>
                      <CopyClipboardComponent
                        className="RobotoMono"
                        sx={{
                          paddingInline: 1,
                          fontWeight: "bold",
                          wordBreak: "keep-all",
                          textAlign: "center",
                          color: theme.palette.success.main,
                        }}
                        text={task.fArticle.arRef}
                      />
                      <CopyClipboardComponent
                        hoverText={t("word.refSupplier")}
                        text={task.fArticleAfReffourniss}
                        sx={{ wordBreak: "keep-all", textAlign: "center" }}
                      />
                    </TableCell>
                    <TableCell sx={{ border: "none" }}>
                      {task.fArticle.arDesign}
                    </TableCell>
                    <TableCell sx={{ border: "none" }}>
                      <Tooltip title={t("word.quantityInvoiced")}>
                        <Typography component="span">
                          {task.quantity}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ border: "none" }}>
                      <Tooltip title={t("word.priceInvoiced")}>
                        <Typography component="span">
                          {priceFormat(
                            Number(task.unitPrice) * 100,
                            i18n.language,
                            "EUR"
                          )}
                          (total:{" "}
                          {priceFormat(
                            Number(task.unitPrice) * 100 * task.quantity,
                            i18n.language,
                            "EUR"
                          )}
                          )
                        </Typography>
                      </Tooltip>
                    </TableCell>
                  </>
                ) : (
                  <TableCell
                    colSpan={colSpanFDocligne}
                    sx={{ border: "none", paddingX: 0 }}
                  ></TableCell>
                )}

                {!transformDoTypes.includes(doTypeDto.doType) || task.done ? (
                  <TableCell
                    colSpan={colSpanTask}
                    sx={{ border: "none", paddingX: 0 }}
                  ></TableCell>
                ) : (
                  <>
                    {task.arRef ? (
                      <>
                        <TableCell sx={{ border: "none" }}>
                          <Tooltip title={t("word.success")}>
                            <DoneIcon color="success" />
                          </Tooltip>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <CopyClipboardComponent
                            hoverText={t("word.refSupplier")}
                            text={task.afReffourniss}
                            sx={{ wordBreak: "keep-all" }}
                          />
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Tooltip title={t("word.quantityInvoiced")}>
                            <Typography component="span">
                              {task.quantity}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Tooltip title={t("word.priceInvoiced")}>
                            <Typography component="span">
                              {priceFormat(
                                Number(task.unitPrice) * 100,
                                i18n.language,
                                "EUR"
                              )}
                              (total:{" "}
                              {priceFormat(
                                Number(task.unitPrice) * 100 * task.quantity,
                                i18n.language,
                                "EUR"
                              )}
                              )
                            </Typography>
                          </Tooltip>
                        </TableCell>
                      </>
                    ) : (
                      <TableCell colSpan={colSpanTask} sx={{ border: "none" }}>
                        <Typography>{t("sentence.edi.notFound")}</Typography>
                        <pre>{JSON.stringify(task, undefined, 2)}</pre>
                      </TableCell>
                    )}
                  </>
                )}
              </React.Fragment>
            ))}
          </TableRow>
          {!task.done &&
            task.possibleFDoclignes &&
            task.possibleFDoclignes.length > 0 && (
              <>
                <TableRow
                  sx={{
                    ...(index % 2 === 0 && {
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                    }),
                  }}
                >
                  {doTypeDtos.map((doTypeDto) => (
                    <React.Fragment key={doTypeDto.doType}>
                      <TableCell
                        colSpan={colSpanFDocligne}
                        sx={{
                          border: "none",
                          paddingX: 0,
                          textAlign: "center",
                        }}
                      >
                        {transformDoTypes.includes(doTypeDto.doType) && (
                          <>
                            {error && (
                              <FormHelperText error>{error}</FormHelperText>
                            )}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checked === null}
                                  onChange={(event, isChecked) => {
                                    setError(undefined);
                                    setChecked(isChecked ? null : undefined);
                                  }}
                                />
                              }
                              label={t("word.none")}
                            />
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        colSpan={colSpanTask}
                        sx={{ border: "none", paddingX: 0 }}
                      ></TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
                {task.possibleFDoclignes.map(
                  (possibleFDocligne, indexPossibleFDocligne) => {
                    let showHeader =
                      possibleFDocligne.fDocentete &&
                      possibleFDocligne.fDocentete.doPiece !== lastDoPiece;
                    if (possibleFDocligne.fDocentete) {
                      lastDoPiece = possibleFDocligne.fDocentete.doPiece;
                    }
                    return (
                      <React.Fragment key={indexPossibleFDocligne}>
                        {showHeader && (
                          <TableRow
                            sx={{
                              ...(index % 2 === 0 && {
                                backgroundColor: "rgba(0, 0, 0, 0.05)",
                              }),
                            }}
                          >
                            {doTypeDtos.map((doTypeDto) => (
                              <React.Fragment key={doTypeDto.doType}>
                                <TableCell
                                  colSpan={colSpanFDocligne}
                                  sx={{
                                    border: "none",
                                    ...(transformDoTypes.includes(
                                      doTypeDto.doType
                                    ) && {
                                      borderLeft:
                                        "2px " + doTypeDto.color + " solid",
                                      borderRight:
                                        "2px " + doTypeDto.color + " solid",
                                      borderTop:
                                        "2px " + doTypeDto.color + " solid",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dashed",
                                    }),
                                  }}
                                >
                                  {transformDoTypes.includes(
                                    doTypeDto.doType
                                  ) && (
                                    <FDocenteteHeader
                                      fDocligne={possibleFDocligne}
                                    />
                                  )}
                                </TableCell>
                                <TableCell
                                  colSpan={colSpanTask}
                                  sx={{ border: "none", paddingX: 0 }}
                                ></TableCell>
                              </React.Fragment>
                            ))}
                          </TableRow>
                        )}
                        <TableRow
                          sx={{
                            ...(index % 2 === 0 && {
                              backgroundColor: "rgba(0, 0, 0, 0.05)",
                            }),
                          }}
                        >
                          {doTypeDtos.map((doTypeDto) => (
                            <React.Fragment key={doTypeDto.doType}>
                              {transformDoTypes.includes(doTypeDto.doType) ? (
                                <>
                                  <TableCell
                                    sx={{
                                      border: "none",
                                      borderLeft:
                                        "2px " + doTypeDto.color + " solid",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dotted",
                                    }}
                                  >
                                    {possibleFDocligne.fArticle &&
                                      possibleFDocligne.fArticle?.arRef ===
                                        task.arRef && (
                                        <Checkbox
                                          checked={
                                            possibleFDocligne.dlNo ===
                                            checked?.dlNo
                                          }
                                          onChange={(event, isChecked) => {
                                            setError(undefined);
                                            setChecked(
                                              isChecked
                                                ? {
                                                    dlNo: possibleFDocligne.dlNo,
                                                    doType:
                                                      possibleFDocligne.doType,
                                                    doPiece:
                                                      possibleFDocligne
                                                        .fDocentete.doPiece,
                                                  }
                                                : undefined
                                            );
                                          }}
                                        />
                                      )}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      border: "none",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dotted",
                                    }}
                                  >
                                    {possibleFDocligne.fArticle && (
                                      <CopyClipboardComponent
                                        className="RobotoMono"
                                        sx={{
                                          paddingInline: 1,
                                          fontWeight: "bold",
                                          wordBreak: "keep-all",
                                          textAlign: "center",
                                          color: theme.palette.success.main,
                                        }}
                                        text={possibleFDocligne.fArticle.arRef}
                                      />
                                    )}
                                    {possibleFDocligne.fArticle &&
                                      possibleFDocligne.fArticle?.arRef ===
                                        task.arRef && (
                                        <>
                                          <CopyClipboardComponent
                                            hoverText={t("word.refSupplier")}
                                            text={task.fArticleAfReffourniss}
                                            sx={{
                                              wordBreak: "keep-all",
                                              textAlign: "center",
                                            }}
                                          />
                                        </>
                                      )}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      border: "none",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dotted",
                                    }}
                                  >
                                    {possibleFDocligne.dlDesign}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      border: "none",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dotted",
                                    }}
                                  >
                                    {Number(possibleFDocligne.dlQte)}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      border: "none",
                                      borderRight:
                                        "2px " + doTypeDto.color + " solid",
                                      borderBottom:
                                        "2px " + doTypeDto.color + " dotted",
                                    }}
                                  >
                                    {priceFormat(
                                      (Number(possibleFDocligne.dlMontantht) *
                                        100) /
                                        Number(possibleFDocligne.dlQte),
                                      i18n.language,
                                      "EUR"
                                    )}
                                    (total:{" "}
                                    {priceFormat(
                                      Number(possibleFDocligne.dlMontantht) *
                                        100,
                                      i18n.language,
                                      "EUR"
                                    )}
                                    )
                                  </TableCell>
                                </>
                              ) : (
                                <TableCell
                                  sx={{ border: "none" }}
                                  colSpan={colSpanFDocligne}
                                ></TableCell>
                              )}
                              <TableCell
                                sx={{ border: "none" }}
                                colSpan={colSpanTask}
                              ></TableCell>
                            </React.Fragment>
                          ))}
                        </TableRow>
                      </React.Fragment>
                    );
                  }
                )}
              </>
            )}
        </>
      );
    }
  )
);

const InvoiceFDocligneComponent = React.memo(
  React.forwardRef(
    (
      { fDocligne, tasks, doTypeDtos, doPieceDestination, index }: State2,
      ref
    ) => {
      const { t, i18n } = useTranslation();
      const theme = useTheme();
      const getCheckedTasks = React.useCallback(() => {
        const result: number[] = [];
        if (tasks) {
          // @ts-ignore
          for (const [index, task] of tasks.entries()) {
            if (!task.done) {
              result.push(index);
            }
          }
        }
        return result;
      }, [tasks]);
      const [checkedTasks, setCheckedTasks] = React.useState(getCheckedTasks());

      const getShowBorderX = React.useCallback(
        (doType: number) => {
          let prefix =
            doTypeDtos.find((d) => d.doType === doType)?.suffix ?? "";
          prefix = prefix.charAt(0).toUpperCase() + prefix.slice(1);
          return (
            (fDocligne.display[doType] !== "" &&
              (fDocligne.doType === doType ||
                // @ts-ignore
                fDocligne["dlPiece" + prefix] !== "")) ||
            (fDocligne.display["prev" + doType] &&
              fDocligne.display["prev" + doType] ===
                fDocligne.display["next" + doType])
          );
        },
        [doTypeDtos, fDocligne]
      );
      const globalNewDoc = getGlobalNewDoc(fDocligne, doTypeDtos);

      const getValue = React.useCallback(() => {
        return tasks.map((t, i) => {
          const r: any = {
            ...t,
            todo: checkedTasks.includes(i),
            doPieceDestination: doPieceDestination,
            doTypeDestination: SAGE_DO_TYPE_ACHAT_CC,
          };
          r.oldId = r.id;
          delete r.id;
          delete r.done;
          return r;
        });
      }, [checkedTasks, doPieceDestination, tasks]);

      useImperativeHandle(ref, () => ({
        getValue() {
          return getValue();
        },
      }));

      React.useEffect(() => {
        setCheckedTasks(getCheckedTasks());
      }, [tasks]); // eslint-disable-line react-hooks/exhaustive-deps

      let rowSpan = tasks.length;
      if (rowSpan === 0) {
        rowSpan = 1;
      }
      const totalQuantityTask = tasks
        .map((t) => t.quantity)
        .reduce((partialSum, a) => partialSum + a, 0);
      return (
        <>
          {globalNewDoc && (
            <TableRow
              sx={{
                ...(index % 2 !== 0 && {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                }),
              }}
            >
              {doTypeDtos.map((doTypeDto) => {
                const newDoc = getNewDoc(fDocligne, doTypeDto.doType);
                return (
                  <React.Fragment key={doTypeDto.doType}>
                    <TableCell
                      colSpan={colSpanFDocligne}
                      sx={{
                        border: "none",
                        ...(getShowBorderX(doTypeDto.doType) && {
                          borderLeft: "2px " + doTypeDto.color + " solid",
                          borderRight: "2px " + doTypeDto.color + " solid",
                        }),
                        ...(newDoc && {
                          borderTop: "2px " + doTypeDto.color + " solid",
                          borderBottom: "2px " + doTypeDto.color + " dashed",
                        }),
                      }}
                    >
                      {newDoc && (
                        <>
                          {fDocligne.doType === doTypeDto.doType ? (
                            <FDocenteteHeader fDocligne={fDocligne} />
                          ) : (
                            <>
                              {doTypeDto.suffix && (
                                <Box sx={{ textAlign: "center" }}>
                                  <CopyClipboardComponent
                                    className="RobotoMono"
                                    component="span"
                                    sx={{ wordBreak: "keep-all" }}
                                    text={
                                      // @ts-ignore
                                      fDocligne[
                                        "dlPiece" +
                                          doTypeDto.suffix
                                            .charAt(0)
                                            .toUpperCase() +
                                          doTypeDto.suffix.slice(1)
                                      ] ?? ""
                                    }
                                  />
                                </Box>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{ border: "none" }}
                      colSpan={colSpanTask}
                    ></TableCell>
                  </React.Fragment>
                );
              })}
            </TableRow>
          )}
          {Array.from(Array(rowSpan).keys()).map((indexTask) => (
            <TableRow
              key={indexTask}
              sx={{
                ...(index % 2 === 0 && {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                }),
              }}
            >
              {doTypeDtos.map((doTypeDto) => {
                const show = fDocligne.doType === doTypeDto.doType;
                let dlQte = fDocligne.dlQte;
                let dlMontantht = "";
                if (fDocligne.doType === doTypeDto.doType) {
                  dlMontantht = fDocligne.dlMontantht;
                } else {
                  if (transformDoTypes.includes(doTypeDto.doType)) {
                    dlMontantht = fDocligne.dlPuBc;
                  }
                  // @ts-ignore
                  dlQte = fDocligne["dlQte" + doTypeDto.suffix];
                }
                const showBorderX = getShowBorderX(doTypeDto.doType);
                const sx: SxProps<Theme> = {
                  border: "none",
                  ...(showBorderX && {
                    borderBottom: "2px " + doTypeDto.color + " dotted",
                  }),
                  ...(!show && {
                    padding: 0,
                  }),
                };
                let priceLine = 0;
                let priceTask = 0;
                if (tasks.length > 0) {
                  priceLine = Math.round(
                    (Number(dlMontantht) * 100) / Number(dlQte)
                  );
                  priceTask = Math.round(
                    Number(tasks[indexTask].unitPrice) * 100
                  );
                }
                return (
                  <React.Fragment key={doTypeDto.doType}>
                    {indexTask === 0 && (
                      <>
                        <TableCell
                          rowSpan={rowSpan}
                          sx={{
                            ...sx,
                            ...(showBorderX && {
                              borderLeft: "2px " + doTypeDto.color + " solid",
                            }),
                          }}
                        >
                          {show && (
                            <Link
                              to={PRODUCT_PAGE + "/" + fDocligne.fArticle.arRef}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              {fDocligne.fArticle.fArticleProp.images ? (
                                <img
                                  src={
                                    (process.env.REACT_APP_API_URL ?? "") +
                                    getUrlFArticleImage(
                                      fDocligne.fArticle.arRef,
                                      fDocligne.fArticle.fArticleProp.images[0],
                                      IMAGE_SIZE_LOGO
                                    )
                                  }
                                  className={"objectFitCover"}
                                  alt={
                                    "[" +
                                    fDocligne.fArticle.arRef +
                                    "] " +
                                    fDocligne.dlDesign
                                  }
                                  loading="lazy"
                                  referrerPolicy="no-referrer"
                                />
                              ) : (
                                <HideImageIcon
                                  sx={{
                                    width: IMAGE_SIZE_LOGO,
                                    height: IMAGE_SIZE_LOGO,
                                  }}
                                />
                              )}
                            </Link>
                          )}
                        </TableCell>
                        <TableCell rowSpan={rowSpan} sx={{ ...sx }}>
                          {showBorderX && (
                            <>
                              {fDocligne.fArticle?.arRef && (
                                <CopyClipboardComponent
                                  className="RobotoMono"
                                  sx={{
                                    paddingInline: 1,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    color: theme.palette.success.main,
                                    wordBreak: "keep-all",
                                    ...(!show && {
                                      marginX: 2,
                                    }),
                                  }}
                                  text={fDocligne.fArticle.arRef}
                                />
                              )}
                              {fDocligne.ediAfReffourniss && (
                                <CopyClipboardComponent
                                  hoverText={t("word.refSupplier")}
                                  text={fDocligne.ediAfReffourniss}
                                  sx={{
                                    paddingInline: 1,
                                    textAlign: "center",
                                    wordBreak: "keep-all",
                                    ...(!show && {
                                      marginX: 2,
                                    }),
                                  }}
                                />
                              )}
                            </>
                          )}
                        </TableCell>
                        <TableCell rowSpan={rowSpan} sx={{ ...sx }}>
                          {show && <>{fDocligne.dlDesign}</>}
                        </TableCell>
                        <TableCell rowSpan={rowSpan} sx={{ ...sx }}>
                          {show && (
                            <>
                              <Tooltip title={t("word.quantityOrdered")}>
                                <Typography component="span">
                                  {Number(dlQte)}
                                </Typography>
                              </Tooltip>
                            </>
                          )}
                        </TableCell>
                        <TableCell
                          rowSpan={rowSpan}
                          sx={{
                            ...sx,
                            ...(showBorderX && {
                              borderRight: "2px " + doTypeDto.color + " solid",
                            }),
                          }}
                        >
                          {show && (
                            <Tooltip title={t("word.priceOrdered")}>
                              <Typography component="span">
                                {priceFormat(
                                  (Number(dlMontantht) * 100) / Number(dlQte),
                                  i18n.language,
                                  "EUR"
                                )}
                                (total:{" "}
                                {priceFormat(
                                  Number(dlMontantht) * 100,
                                  i18n.language,
                                  "EUR"
                                )}
                                )
                              </Typography>
                            </Tooltip>
                          )}
                        </TableCell>
                      </>
                    )}
                    {tasks.length === 0 ? (
                      <>
                        {indexTask === 0 && (
                          <TableCell
                            colSpan={colSpanTask}
                            sx={{ border: "none" }}
                          >
                            {show &&
                              transformDoTypes.includes(doTypeDto.doType) && (
                                <Tooltip title={t("word.reliquat")}>
                                  <CloseIcon color="error" />
                                </Tooltip>
                              )}
                          </TableCell>
                        )}
                      </>
                    ) : (
                      <>
                        {tasks[indexTask].done ? (
                          <TableCell
                            colSpan={colSpanTask}
                            sx={{
                              paddingY: 0,
                              border: "none",
                            }}
                          ></TableCell>
                        ) : (
                          <>
                            <TableCell sx={{ border: "none" }}>
                              <>
                                {transformDoTypes.includes(
                                  doTypeDto.doType
                                ) && (
                                  <>
                                    {totalQuantityTask === Number(dlQte) ? (
                                      <Tooltip title={t("word.success")}>
                                        <DoneIcon color="success" />
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title={t("word.partial")}>
                                        <CloseIcon color="warning" />
                                      </Tooltip>
                                    )}
                                  </>
                                )}
                              </>
                            </TableCell>
                            <TableCell
                              sx={{
                                paddingY: 0,
                                border: "none",
                              }}
                            >
                              {show && (
                                <>
                                  <CopyClipboardComponent
                                    hoverText={t("word.refSupplier")}
                                    text={tasks[indexTask].afReffourniss}
                                    sx={{ wordBreak: "keep-all" }}
                                  />
                                </>
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                paddingY: 0,
                                border: "none",
                                ...(totalQuantityTask !== Number(dlQte) && {
                                  color: theme.palette.error.main,
                                }),
                              }}
                            >
                              {show && (
                                <>
                                  <Tooltip title={t("word.quantityInvoiced")}>
                                    <Typography component="span">
                                      {tasks[indexTask].quantity}
                                    </Typography>
                                  </Tooltip>
                                </>
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                paddingY: 0,
                                border: "none",
                                ...(priceLine > priceTask && {
                                  color: theme.palette.success.main,
                                }),
                                ...(priceLine < priceTask && {
                                  color: theme.palette.error.main,
                                }),
                              }}
                            >
                              {show && (
                                <Tooltip title={t("word.priceInvoiced")}>
                                  <Typography component="span">
                                    {priceFormat(
                                      Number(tasks[indexTask].unitPrice) * 100,
                                      i18n.language,
                                      "EUR"
                                    )}
                                    (total:{" "}
                                    {priceFormat(
                                      Number(tasks[indexTask].unitPrice) *
                                        100 *
                                        tasks[indexTask].quantity,
                                      i18n.language,
                                      "EUR"
                                    )}
                                    )
                                  </Typography>
                                </Tooltip>
                              )}
                            </TableCell>
                          </>
                        )}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </TableRow>
          ))}
        </>
      );
    }
  )
);

const InvoiceSupplierComponent = React.memo(
  React.forwardRef(({ initInvoice }: State, _) => {
    const { t } = useTranslation();
    const [edit, setEdit] = React.useState(!initInvoice?.userIdentifier);
    const [loading, setLoading] = React.useState<boolean>(false);
    const fournisseurs = useAppSelector(
      (state: RootState) => state.globalState.fournisseurs
    );
    const suppliers = useAppSelector(
      (state: RootState) => state.globalState.suppliers
    );
    const getSuppliers = React.useCallback(() => {
      return (
        fournisseurs?.filter((f) => suppliers?.includes(f.userIdentifier)) ?? []
      );
    }, [fournisseurs, suppliers]);
    const [thisSuppliers, setThisSuppliers] = React.useState(getSuppliers());
    const getSupplier = React.useCallback(() => {
      return thisSuppliers.find(
        (s) => s.userIdentifier === initInvoice?.userIdentifier
      );
    }, [initInvoice?.userIdentifier, thisSuppliers]);
    const [supplier, setSupplier] = React.useState(getSupplier());
    const token = useAppSelector((state: RootState) => state.globalState.token);
    const dispatch = useAppDispatch();

    const changeUserIdentifier = React.useCallback(
      async (userIdentifier: string) => {
        if (userIdentifier === "") {
          return;
        }
        setLoading(true);
        const response = await requestApi({
          method: PATCH,
          path: INVOICE_URL + "/" + initInvoice?.id + "?refresh",
          allowError: false,
          token: token,
          body: {
            userIdentifier: userIdentifier,
          },
        });
        if (response.statusCode === 200) {
          dispatch(set({ refreshPage: true }));
        } else if (response.statusCode === 401) {
          toastr.info(t("word.info"), t("error.reconnect"));
        } else {
          for (let message of getErrorApi(response.content)) {
            toastr.error(t("word.error"), t(message));
          }
        }
        setLoading(false);
      },
      [dispatch, initInvoice?.id, t, token]
    );

    React.useEffect(() => {
      setSupplier(getSupplier());
    }, [initInvoice?.userIdentifier]); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
      setThisSuppliers(getSuppliers());
    }, [fournisseurs, suppliers]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {initInvoice && (
          <li>
            {t("word.supplier") + ": "}
            {edit ? (
              <>
                <Select
                  value={supplier?.userIdentifier ?? ""}
                  sx={{
                    minWidth: 120,
                  }}
                  disabled={loading}
                  onChange={(e) => {
                    changeUserIdentifier(e.target.value);
                  }}
                >
                  {!supplier?.userIdentifier && (
                    <MenuItem value="">
                      <em>{t("word.none")}</em>
                    </MenuItem>
                  )}
                  {thisSuppliers.map((s) => (
                    <MenuItem value={s.userIdentifier} key={s.userIdentifier}>
                      [{s.userIdentifier}] {s.ctIntitule}
                    </MenuItem>
                  ))}
                </Select>
                <IconButton onClick={() => setEdit(false)}>
                  <CancelIcon />
                </IconButton>
              </>
            ) : (
              <>
                {initInvoice.userIdentifier}
                {initInvoice.path && (
                  <IconButton onClick={() => setEdit(true)}>
                    <EditIcon />
                  </IconButton>
                )}
              </>
            )}
          </li>
        )}
      </>
    );
  })
);

const InvoiceFooterComponent = React.memo(
  React.forwardRef(({ invoice, doTypeDtos }: State4, _) => {
    const { i18n } = useTranslation();
    const theme = useTheme();

    const getTotal = React.useCallback(
      (doTypeDto: DoTypeInvoiceInterface) => {
        let total = 0;
        if (invoice?.fDoclignes) {
          for (const fDocligne of invoice.fDoclignes) {
            if (fDocligne.doType !== doTypeDto.doType) {
              continue;
            }
            total += Number(fDocligne.dlMontantht);
          }
        }
        return total;
      },
      [invoice]
    );

    const totalTask = (invoice?.invoiceTasks ?? [])
      .filter((invoiceTask: InvoiceTaskInterface) => !invoiceTask.done)
      .map((invoiceTask: InvoiceTaskInterface) => {
        return Number(invoiceTask.unitPrice) * invoiceTask.quantity;
      })
      .reduce((partialSum, a) => partialSum + a, 0);

    return (
      <TableRow
        sx={{
          backgroundColor: theme.palette.primary.main,
        }}
      >
        {doTypeDtos.map((doTypeDto, indexDoTypeDto) => {
          const total = getTotal(doTypeDto);
          return (
            <React.Fragment key={indexDoTypeDto}>
              <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
              <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
              <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
              <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
              <TableCell
                sx={{
                  border: "none",
                  paddingX: 0,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {total > 0 &&
                  priceFormat(Number(total) * 100, i18n.language, "EUR")}
              </TableCell>
              {transformDoTypes.includes(doTypeDto.doType) ? (
                <>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    {priceFormat(Number(totalTask) * 100, i18n.language, "EUR")}
                  </TableCell>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                  <TableCell sx={{ border: "none", paddingX: 0 }}></TableCell>
                </>
              ) : (
                <TableCell
                  colSpan={colSpanTask}
                  sx={{ border: "none", paddingX: 0 }}
                ></TableCell>
              )}
            </React.Fragment>
          );
        })}
      </TableRow>
    );
  })
);

const InvoiceRawDataComponent = React.memo(
  React.forwardRef(({ initInvoice, setInvoice }: State6, _) => {
    const { t } = useTranslation();
    const [edit, setEdit] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const getRawData = React.useCallback(() => {
      try {
        return JSON.stringify(
          JSON.parse(initInvoice?.rawData ?? "{}"),
          null,
          2
        );
      } catch (e) {
        return initInvoice?.rawData ?? "";
      }
    }, [initInvoice?.rawData]);
    const [rawData, setRawData] = React.useState<string>(getRawData());
    const token = useAppSelector((state: RootState) => state.globalState.token);

    const save = React.useCallback(async () => {
      setLoading(true);
      const response = await requestApi({
        method: PATCH,
        path: INVOICE_URL + "/" + initInvoice?.id + "?refresh",
        allowError: true,
        token: token,
        body: {
          rawData: rawData,
        },
      });
      if (response.statusCode === 200) {
        setInvoice(response.content);
      } else if (response.statusCode === 401) {
        toastr.info(t("word.info"), t("error.reconnect"));
      } else {
        for (let message of getErrorApi(response.content)) {
          toastr.error(t("word.error"), t(message));
        }
      }
      setEdit(false);
      setLoading(false);
    }, [initInvoice?.id, rawData, setInvoice, t, token]);

    React.useEffect(() => {
      setRawData(getRawData());
    }, [initInvoice?.rawData]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {initInvoice && (
          <>
            {edit ? (
              <>
                <Box>
                  <Tooltip title={t("word.cancel")}>
                    <IconButton
                      disabled={loading}
                      onClick={() => setEdit(false)}
                    >
                      <CancelIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("word.save")}>
                    <LoadingButton
                      variant="text"
                      color="inherit"
                      sx={{
                        borderRadius: "50%",
                        minWidth: "auto",
                        padding: "8px",
                        color: "rgba(0, 0, 0, 0.54)",
                      }}
                      loading={loading}
                      onClick={save}
                    >
                      <SaveIcon />
                    </LoadingButton>
                  </Tooltip>
                </Box>
                <TextareaAutosize
                  minRows={4}
                  value={rawData}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setRawData(e.target.value);
                  }}
                />
              </>
            ) : (
              <>
                <IconButton
                  onClick={() => {
                    setEdit(true);
                    setRawData(getRawData());
                  }}
                >
                  <EditIcon />
                </IconButton>
                <pre>{getRawData()}</pre>
              </>
            )}
          </>
        )}
      </>
    );
  })
);

const InvoiceComponent: React.FC<State> = React.memo(({ initInvoice }) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const getThisDoTypeDtos = React.useCallback(
    (thisInvoice: InvoiceInterface | undefined): DoTypeInvoiceInterface[] => {
      let thisDoTypeDtos = doTypeDtos.filter((x) => {
        return [
          SAGE_DO_TYPE_ACHAT_DA,
          SAGE_DO_TYPE_ACHAT_PC,
          SAGE_DO_TYPE_ACHAT_CC,
        ].includes(x.doType);
      });
      const isBonLivraison = thisInvoice?.bonLivraison === "true";
      if (isBonLivraison) {
        thisDoTypeDtos = doTypeDtos.filter((x) => {
          return [SAGE_DO_TYPE_ACHAT_LI, SAGE_DO_TYPE_ACHAT_FA].includes(
            x.doType
          );
        });
      }
      return thisDoTypeDtos;
    },
    []
  );
  const formatInvoice = React.useCallback(
    (thisInvoice: InvoiceInterface | undefined) => {
      let thisDoTypeDtos = getThisDoTypeDtos(thisInvoice);
      addDisplayInvoiceFDocligne(thisInvoice?.fDoclignes ?? [], thisDoTypeDtos);
      if (thisInvoice?.fDoclignes) {
        for (const fDocligne of thisInvoice.fDoclignes) {
          fDocligne.ref = React.createRef();
        }
      }
      if (thisInvoice?.invoiceTasks) {
        for (const task of thisInvoice.invoiceTasks) {
          task.ref = React.createRef();
        }
      }
      return thisInvoice;
    },
    [getThisDoTypeDtos]
  );
  const [invoice, setInvoice] = React.useState<InvoiceInterface | undefined>(
    formatInvoice(initInvoice)
  );
  let thisDoTypeDtos = getThisDoTypeDtos(invoice);
  const [loading, setLoading] = React.useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const token = useAppSelector((state: RootState) => state.globalState.token);

  const applyTaxes = React.useCallback(async () => {
    setLoading(true);
    const thisInvoice: InvoiceInterface = clone(invoice);
    let tasksToSend: InvoiceTaskInterface[] = [];
    if (thisInvoice?.fDoclignes) {
      for (const fDocligne of thisInvoice?.fDoclignes) {
        tasksToSend = [
          ...tasksToSend,
          ...(fDocligne.ref.current?.getValue() ?? []),
        ];
      }
    }
    if (thisInvoice?.invoiceTasks) {
      for (const task of thisInvoice?.invoiceTasks.filter(
        (t) => t.dlNo === null
      )) {
        const v = task.ref.current?.getValue();
        if (v === undefined) {
          setLoading(false);
          setInvoice(formatInvoice(thisInvoice)); // important otherwise task.ref.current becomes null
          return;
        }
        if (v) {
          tasksToSend.push(v);
        }
      }
    }
    for (const taskToSend of tasksToSend) {
      delete taskToSend.ref;
      // @ts-ignore
      delete taskToSend.sort;
      // @ts-ignore
      delete taskToSend.fArticle;
      // @ts-ignore
      delete taskToSend.possibleFDoclignes;
    }
    const response = await requestApi({
      method: PATCH,
      path: INVOICE_URL + "/" + thisInvoice?.id + "/tasks",
      allowError: true,
      token: token,
      timeout: 120_000,
      body: {
        invoiceTasks: tasksToSend,
      },
    });
    if (response.statusCode === 200) {
      setInvoice(formatInvoice(response.content));
    } else {
      for (let message of getErrorApi(response.content)) {
        toastr.error(t("word.error"), t(message));
      }
    }
    setLoading(false);
  }, [invoice, token, formatInvoice, t]);

  const refresh = React.useCallback(async () => {
    setLoading(true);
    const response = await requestApi({
      method: PATCH,
      path: INVOICE_URL + "/" + invoice?.id + "/refresh",
      allowError: true,
      token: token,
      body: {},
    });
    if (response.statusCode === 200) {
      setInvoice(formatInvoice(response.content));
    } else {
      for (let message of getErrorApi(response.content)) {
        toastr.error(t("word.error"), t(message));
      }
    }
    setLoading(false);
  }, [formatInvoice, invoice?.id, t, token]);

  const changePropInvoice = React.useCallback(
    async (prop: string, value: any) => {
      setLoading(true);
      const response = await requestApi({
        method: PATCH,
        path: INVOICE_URL + "/" + invoice?.id + "?refresh",
        allowError: false,
        token: token,
        body: {
          [prop]: value,
        },
      });
      if (response.statusCode === 200) {
        setInvoice(formatInvoice(response.content));
        dispatch(set({ newEdi: response.content.newEdi }));
      } else if (response.statusCode === 401) {
        toastr.info(t("word.info"), t("error.reconnect"));
      } else {
        for (let message of getErrorApi(response.content)) {
          toastr.error(t("word.error"), t(message));
        }
      }
      setLoading(false);
    },
    [dispatch, formatInvoice, invoice?.id, t, token]
  );

  React.useEffect(() => {
    setInvoice(formatInvoice(initInvoice));
  }, [initInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

  const doPieceDestination =
    invoice?.fDoclignes.find((f) => {
      if (invoice?.bonLivraison === "true") {
        return f.doType === SAGE_DO_TYPE_ACHAT_FA;
      }
      return f.doType === SAGE_DO_TYPE_ACHAT_CC;
    })?.fDocentete.doPiece ?? null;

  let fDocligneIndex = 0;
  const thisInvoiceTasks =
    invoice?.invoiceTasks.filter((t) => t.dlNo === null && !t.done) ?? [];
  return (
    <>
      {!invoice ? (
        <SearchComponent nbColumn={1} nbLines={1} />
      ) : (
        <>
          {invoice?.errors && invoice.errors.length > 0 && (
            <Box sx={{ marginBottom: 2 }}>
              {invoice.errors.map((error, indexError) => (
                <Alert severity="error" key={indexError}>
                  {error}
                </Alert>
              ))}
            </Box>
          )}
          <Accordion>
            <AccordionSummary
              sx={{
                paddingY: 1,
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography variant="h5">{t("word.edi")}</Typography>
              <CopyClipboardComponent
                text={invoice.rawData}
                icon={<ContentCopyIcon />}
                sx={{ wordBreak: "keep-all" }}
              />
            </AccordionSummary>
            <AccordionDetails>
              <InvoiceRawDataComponent
                initInvoice={invoice}
                setInvoice={(newInvoice: InvoiceInterface) => {
                  setInvoice(formatInvoice(newInvoice));
                }}
              />
            </AccordionDetails>
          </Accordion>
          <ul>
            <li>{t("word.id") + ": " + invoice.id}</li>
            <InvoiceSupplierComponent initInvoice={invoice} />
            <li>{t("word.invoice") + ": " + invoice.invoiceId}</li>
            <li>
              {t("word.received") +
                ": " +
                new Date(invoice.created).toLocaleString(i18n.language, {
                  dateStyle: "long",
                  timeStyle: "medium",
                  timeZone: "America/Cuiaba",
                })}
            </li>
            <li>
              {t("word.date") +
                ": " +
                new Date(invoice.invoiceDate).toLocaleString(i18n.language, {
                  dateStyle: "long",
                  timeZone: "Etc/UTC",
                })}
            </li>
            <li>
              {t("column.isNew") + ": "}
              <LoadingButton
                variant="text"
                color="inherit"
                sx={{
                  borderRadius: "50%",
                  minWidth: "auto",
                  padding: "12px",
                }}
                loading={loading}
                onClick={() => changePropInvoice("isNew", !invoice?.isNew)}
              >
                {invoice.isNew ? (
                  <DoneIcon color="success" />
                ) : (
                  <CloseIcon color="error" />
                )}
              </LoadingButton>
            </li>
            <li>
              {t("word.fdocentete.doType.3") + ": "}
              <LoadingButton
                variant="text"
                color="inherit"
                sx={{
                  borderRadius: "50%",
                  minWidth: "auto",
                  padding: "12px",
                }}
                loading={loading}
                onClick={() =>
                  changePropInvoice(
                    "bonLivraison",
                    invoice.bonLivraison === "true" ? null : "true"
                  )
                }
              >
                {invoice.bonLivraison === "true" ? (
                  <DoneIcon color="success" />
                ) : (
                  <CloseIcon color="error" />
                )}
              </LoadingButton>
            </li>
            {invoice.similarDoPieces && invoice.similarDoPieces.length > 0 && (
              <li>
                {t("word.similarDoPieces") + ": " + invoice.similarDoPieces}
              </li>
            )}
            {invoice.path && (
              <li>
                <a
                  target="_blank"
                  href={
                    (process.env.REACT_APP_API_URL ?? "") +
                    invoice.path
                      ?.replace("/srv", "")
                      ?.replace("/app/public", "")
                  }
                  rel="noreferrer"
                >
                  {t("word.bill")}
                </a>
              </li>
            )}
            {invoice.model && <li>{t("word.model") + ": " + invoice.model}</li>}
          </ul>
          <Table size="small" sx={{ width: "auto", marginY: 1 }}>
            <TableHead>
              <TableRow>
                {thisDoTypeDtos.map((doTypeDto) => (
                  <React.Fragment key={doTypeDto.doType}>
                    <TableCell colSpan={colSpanFDocligne}>
                      <Typography sx={{ textAlign: "center" }}>
                        {t("word.fdocentete.doType." + doTypeDto.doType)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {transformDoTypes.includes(doTypeDto.doType) && (
                        <>{t("word.validation")}</>
                      )}
                    </TableCell>
                    <TableCell colSpan={colSpanTask - 1}>
                      {transformDoTypes.includes(doTypeDto.doType) &&
                        invoice.invoiceTasks.length > 0 && (
                          <Typography sx={{ textAlign: "center" }}></Typography>
                        )}
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {invoice?.fDoclignes.map((fDocligne) => {
                if (getGlobalNewDoc(fDocligne, thisDoTypeDtos)) {
                  fDocligneIndex++;
                }
                fDocligneIndex++;
                return (
                  <InvoiceFDocligneComponent
                    key={fDocligne.dlNo}
                    index={fDocligneIndex}
                    fDocligne={fDocligne}
                    ref={fDocligne.ref}
                    doTypeDtos={thisDoTypeDtos}
                    doPieceDestination={doPieceDestination}
                    tasks={invoice.invoiceTasks.filter(
                      (t) => t.dlNo === fDocligne.dlNo
                    )}
                  />
                );
              })}
              {thisInvoiceTasks.length > 0 && (
                <>
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                    }}
                  >
                    {thisDoTypeDtos.map((doTypeDto) => (
                      <React.Fragment key={doTypeDto.doType}>
                        <TableCell
                          colSpan={colSpanFDocligne}
                          sx={{ textAlign: "center" }}
                        >
                          {transformDoTypes.includes(doTypeDto.doType) && (
                            <Typography
                              variant="h5"
                              sx={{
                                color: theme.palette.primary.contrastText,
                              }}
                            >
                              {t("word.addition")}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell colSpan={colSpanTask}></TableCell>
                      </React.Fragment>
                    ))}
                  </TableRow>
                  {thisInvoiceTasks.map((task, indexTask) => {
                    if (thisInvoiceTasks.length > 0 && indexTask === 0) {
                      fDocligneIndex++;
                    }
                    fDocligneIndex++;
                    return (
                      <InvoiceTaskComponent
                        doTypeDtos={thisDoTypeDtos}
                        task={task}
                        ref={task.ref}
                        index={fDocligneIndex}
                        key={indexTask}
                        doPieceDestination={doPieceDestination}
                      />
                    );
                  })}
                </>
              )}
              <InvoiceFooterComponent
                invoice={invoice}
                doTypeDtos={thisDoTypeDtos}
                index={fDocligneIndex}
              />
            </TableBody>
          </Table>
          {invoice.userIdentifier &&
            invoice?.invoiceTasks &&
            invoice.invoiceTasks.filter((i) => i.done).length === 0 && (
              <Container maxWidth="xl" sx={{ marginY: 3 }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    {(invoice.dlNoTransformed === null ||
                      invoice.dlNoTransformed.length === 0) && (
                      <LoadingButton
                        variant="contained"
                        onClick={refresh}
                        loading={loading}
                      >
                        {t("word.refresh")}
                      </LoadingButton>
                    )}
                  </Box>
                  <Box>
                    {invoice.invoiceTasks.filter((i) => !i.done).length > 0 && (
                      <LoadingButton
                        variant="contained"
                        onClick={applyTaxes}
                        disabled={!invoice.isNew}
                        loading={loading}
                      >
                        {t("word.apply")}
                      </LoadingButton>
                    )}
                  </Box>
                </Box>
              </Container>
            )}
        </>
      )}
    </>
  );
});

export default InvoiceComponent;
